import { render } from "./AppealsDonationsPage.vue?vue&type=template&id=369880ab&scoped=true"
import script from "./AppealsDonationsPage.vue?vue&type=script&lang=js"
export * from "./AppealsDonationsPage.vue?vue&type=script&lang=js"

import "./AppealsDonationsPage.vue?vue&type=style&index=0&id=369880ab&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-369880ab"]])

export default __exports__